export class IpcEventNames {
  // Track Statistics
  public static readonly ON_GET_TRACK_STATISTICS = 'track/get-statistics';
  public static readonly ON_GET_TRACK_STATISTICS_RESPONSE =
    'track/get-statistics';
  public static readonly ON_TRACK_STATISTICS_UPDATE = 'track/update-statistics';

  // My Music
  public static readonly ON_GET_MY_MUSIC = 'my-music/get';
  public static readonly ON_MY_MUSIC_GET_FOLDERS = 'my-music/get-folder';
  public static readonly ON_MY_MUSIC_GET_FOLDER_TRACKS =
    'my-music/get-folder-tracks';
  public static readonly ON_MY_MUSIC_ADD_FOLDER = 'my-music/add-folder';
  public static readonly ON_MY_MUSIC_RESCAN_FOLDER = 'my-music/rescan-folder';
  public static readonly ON_MY_MUSIC_RESCAN_FOLDERS = 'my-music/rescan-folders';
  public static readonly ON_MY_MUSIC_DELETE_FOLDER = 'my-music/delete-folder';
  public static readonly ON_MY_MUSIC_DELETE_TRACK = 'my-music/delete-track';
  public static readonly ON_MY_MUSIC_RESCAN_TRACK = 'my-music/rescan-track';
  public static readonly ON_MY_MUSIC_RESCAN_TRACKS = 'my-music/rescan-tracks';
  public static readonly ON_MY_MUSIC_SCAN_TRACK = 'my-music/scan-track';
  public static readonly ON_MY_MUSIC_CLEAR_LOCAL_TRACKS =
    'my-music/clear-local-tracks';
  public static readonly ON_MY_MUSIC_GET_LOCAL_TRACK_COUNT =
    'my-music/get-local-track-count';
  public static readonly ON_HEALTH_REPORT_GET_ISSUE_DETAILS =
    'health-report/get-issue-details';
}
